import { ChangeDetectorRef, Component, OnInit, HostListener } from '@angular/core';
import { WindowRef } from '../../utils/window';
import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AuthorizationService } from '../authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateUtil } from '../../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service'
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';



declare var grecaptcha: any;


@Component({
    selector: 'div.dtf-passwordresetconfirmpage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './passwordresetconfirm.component.html',
    providers: [WindowRef]
})

export class PasswordResetConfirmComponent implements OnInit {

    constructor(router: Router, window: WindowRef,
                public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
                public translate: TranslateService, public dtfhomepageService: DTFHomepageService,
                private cdRef: ChangeDetectorRef
                ) {
        this.router = router;
        this._window = window;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
        this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }
    private _window: WindowRef;
    router: Router;
    public registration: any;
    isAuthenticated = false;
    ciamLoginUrl = '';
    contextPath = '';
    currentCountry: string;
    isCanadaPortal = false;
    isReset = false;
    userExist = false;
    loginLoaded = true;
    rendered: any;
    isAuth = '';
    userId = '';
    password = '';
    repassword = '';
    token ='';
    language = '';
    hide = false;
    hide2 = false;
    openLoginModal = false;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';
    usUrl: string;
    caUrl: string;
    brandId: string;
    adminFlow:string;
    targetRedirect = '';
    registrationRedirect = '';
    baseUrl = '';
    logoutRedirect = '';
    classicRedirect = '';
    environment = '';
    wrongPassword:boolean=false;
    resetRequest: any = {};
    invalidToken = false;
    confirmReset = false;
    bodyLoaded=false;
    userIDcheck = false;
    hasUpperCase = false;
    hasLowerCase=false;
    hasNumeric = false;
    hasMinimum = false;
    hasMaximum =false;
    reentercheck=false;

    resetForm: FormGroup;
    formValidationClasses = {
      'mbfs-error': true,
    };

    buildForm() {
      this.resetForm = this.fb.group({
        password: [''],
        repassword: ['']
      });
    }

    ngOnInit() {
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
          this.currentCountry = val;
          this.cdRef.detectChanges();
      });
      this.auth.cast.subscribe(data => {
        this.isAuthenticated = data;
        this.cdRef.detectChanges();
      });
      this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      this.auth.isAuthenticated(); // Checks if user is authenticated
      let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
      element.click();
      this.token = (this._window.nativeWindow as any).mbfs.passwordreset;
      this.adminFlow = (this._window.nativeWindow as any).mbfs.adminFlow;

      if(this.adminFlow ==='true'){
        this.validateAdminTokenFromEmail();
      }
      else{
        this.validateTokenFromEmail();
      }
      // this.onClickLogin(this.e);
    }

    onClickLogin(e: Event): void {
      this.buildForm();
      //build login form
      this.openLoginModal = true;
      this.resetForm.get('password').setValidators(
            Validators.compose([Validators.required,
              Validators.minLength(12),
              Validators.maxLength(30),
              this.passwordValidationCheck(),
              Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
      );
      this.resetForm.get('repassword').setValidators(
        Validators.compose([Validators.required,
          Validators.minLength(12),
          Validators.maxLength(30),
          this.passwordEqualsCheck(),
          Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')]),
  );          

      }

       passwordValidationCheck(): ValidatorFn {
        return (control:AbstractControl) : ValidationErrors | null => {
          let passwordvalue = this.resetForm.get('password').value;

          let notUserId = false;
            if(passwordvalue != this.userId){
              notUserId = true;
            }
            this.userIDcheck = notUserId;
            this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
            this.hasLowerCase = /[a-z]+/.test(passwordvalue);
            this.hasNumeric = /[0-9]+/.test(passwordvalue);
            this.hasMinimum = passwordvalue.length >= 12;
            this.hasMaximum = passwordvalue.length <= 30;
            const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck;
      
            return !passwordValid ? {passwordStrength:true}: null;
        }
      }
      
      passwordEqualsCheck(): ValidatorFn {
        return (control:AbstractControl) : ValidationErrors | null => {
          let resetvalue = this.resetForm.get('repassword').value;
          let passwordvalue = this.resetForm.get('password').value;
            let notpasswordEqual = false;
            if(resetvalue === passwordvalue){
              notpasswordEqual = true;
            }
            this.reentercheck = notpasswordEqual;      
            const passwordValid =  this.reentercheck;
      
            return !passwordValid ? {passwordStrength:true}: null;
        }
      }
      

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  
  openLogin(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    let redirect = '';
    if(this.adminFlow ==='true'){
    this.translate.get('LoginModal.AdminRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
    }
    else{
      this.translate.get('LoginModal.LoginRedirect').subscribe((data:any)=> {
        redirect= this.usUrl +  data;
       });
    }
     window.location.href = redirect;
  }


  changeType(input_field_password, bool){
    if(input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    bool = !bool;
  }

  validateTokenFromEmail(){
    let tokenRequest = {
      token : this.token
    };

    this.auth.validateTokenFromEmail(tokenRequest).subscribe(res => {
      if(res.statusMessage ==='SUCCESS'){
        this.userId = res.userId;
        this.invalidToken = true;
      }
      else{
        this.invalidToken = false;
      }
      this.bodyLoaded = true;
      this.cdRef.detectChanges();
    });
  }

  validateAdminTokenFromEmail(){
    let tokenRequest = {
      token : this.token
    };
    this.auth.validateAdminTokenFromEmail(tokenRequest).subscribe(res => {
      if(res.statusMessage ==='SUCCESS'){
        this.userId = res.userId;
        this.invalidToken = true;
      }
      else{
        this.invalidToken = false;
      }
      this.bodyLoaded = true;
      this.cdRef.detectChanges();
    });
  }

  prepareToSaveNewPassword(e: Event) {
    this.resetRequest = {};
    if (!this.resetForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
        this.cdRef.detectChanges();
       });
      this.serviceErrorOccurred = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.serviceErrorOccurred = false;
        this.cdRef.detectChanges();
      }, 2000);  //2s
      return;
    }
    this.repassword = this.resetForm.get('repassword').value;
    this.resetRequest = {
      userId : this.userId,
      password : this.repassword
      };

  if(this.adminFlow ==='true'){
  this.auth.prepareToSaveAdminNewPassword(this.resetRequest).subscribe(res => {
    if(res.statusMessage === 'SUCCESS')
    {
      this.confirmReset = true;
    }
    else {
      // If checks to load BE error messages based on language
       if (this.language === 'en-CA') {
         this.serviceErrorDesc = res.status.message.shortMessage_EN;
       } else if (this.language === 'fr-CA') {
         this.serviceErrorDesc = res.status.message.shortMessage_FR;
       } else {
         this.serviceErrorDesc = res.status.message.shortMessage;
       }
       this.serviceErrorOccurred = true;
       this.cdRef.detectChanges();
       setTimeout(() => {
         this.serviceErrorOccurred = false;
         this.cdRef.detectChanges();
       }, 2000);  //2s
     }
     this.cdRef.detectChanges();
  }, () => {
    this.cdRef.detectChanges();
  });
}
else{
  this.auth.prepareToSaveNewPassword(this.resetRequest).subscribe(res => {
    if(res.statusMessage === 'SUCCESS')
    {
      this.confirmReset = true;
    }
    else {
      // If checks to load BE error messages based on language
       if (this.language === 'en-CA') {
         this.serviceErrorDesc = res.status.message.shortMessage_EN;
       } else if (this.language === 'fr-CA') {
         this.serviceErrorDesc = res.status.message.shortMessage_FR;
       } else {
         this.serviceErrorDesc = res.status.message.shortMessage;
       }
       this.serviceErrorOccurred = true;
       this.cdRef.detectChanges();
       setTimeout(() => {
         this.serviceErrorOccurred = false;
         this.cdRef.detectChanges();
       }, 2000);  //2s
     }
     this.cdRef.detectChanges();
  }, () => {
    this.cdRef.detectChanges();
  });
}

}

reregister(){
  this.translate.get('NavHeader.RegisterURL').subscribe((data: any) => {
    let redirect= this.baseUrl + data;
    window.location.href = redirect;
  });
}
}